import "./Slideshow.css"
import farm from "../../photos/farm.jpeg";
import cow from "../../photos/cow.jpeg";
import chicken from "../../photos/chicken.jpeg";
import piglet from "../../photos/piglet.jpeg";


import {useEffect, useState} from "react";
import {setStyleSlider, setStyleBanner, setStyleButton} from './SliderUtils'
import WelcomeBanner from "./WelcomeBanner";
import {useOnResize} from "../../../utils";

const Slideshow = () => {
    //There is an unmount issue because widthX changes in this functional component whenever someone zooms in

    let widthX = useOnResize()
    const [isMounted, setIsMounted] = useState(false)
    const [sliderIndex, setSliderIndex] = useState(0)
    const [initialInterval, setInitialInterval] = useState(0)

    //After the component is mounted then we can start rendering
    useEffect(()=> {
        setIsMounted(true)
    }, [])

    //get elements from WelcomeBanner
    let slider = document.querySelectorAll("div.slider > img")
    // let caption = document.querySelectorAll("div.welcome-banner > h2")
    let info = document.querySelectorAll("div.welcome-banner > div.welcome-info")
    let btn = document.querySelectorAll("div.welcome-info > div.discover-more-btn")

    //update slider initially (after component is mounted)
    useEffect(()=> {
        if(isMounted) {
            setStyleSlider(slider, sliderIndex, false)
            // setStyleCaption(caption, sliderIndex, false)
            setStyleBanner(info, sliderIndex, false)
            setStyleButton(btn, sliderIndex, false)

            setInitialInterval(5000)
        }//eslint-disable-next-line
    }, [isMounted])

    const renderSlide = () => {
        for (let i = 0; i < slider.length; ++i){
            if (sliderIndex === i) {
                setStyleSlider(slider, i, false)
                setStyleButton(btn, i, false)
                if(isMounted) {
                    // setStyleCaption(caption, i, false)
                    setStyleBanner(info, i, false)
                }
            }
            else {
                setStyleSlider(slider, i, true)
                setStyleButton(btn, i, true)
                if(isMounted) {
                    // setStyleCaption(caption, i, true)
                    setStyleBanner(info, i, true)
                }
            }
        }
    }

    const nextSlide = () => {
        //always want to start at slide 0 so hence, renderSlide() is before incrementing index
        setSliderIndex(sliderIndex + 1)
    }

    const prevSlide = () => {
        //always want to go to previous slide from current, so subtract then renderSlide
        setSliderIndex(sliderIndex - 1)
    }

    //slideshow effect every 6 seconds
    useEffect(()=> {
        const interval = setInterval (()=> {
            nextSlide()
        }, initialInterval)
        return () => {
            clearInterval(interval)
        }
    })

    //when page load and on forward, load the slide
    renderSlide()

    //reset sliderIndex
    useEffect(() => {
        if (sliderIndex >= slider.length)
            setSliderIndex(0)
        else if (sliderIndex < 0)
            setSliderIndex(slider.length - 1)
    }, [slider.length, sliderIndex])
    return (
        <div className= "main-slider">
            <div className='slider' id='slider1'>
                <img alt='farm' src={farm}/>
                <WelcomeBanner/>
            </div>

            <div className = 'slider' id = 'slider2'>
                <img alt = 'cow' src = {cow} />
                <WelcomeBanner/>
            </div>
            <div className = 'slider' id = 'slider3'>
                <img alt = 'chicken' src = {chicken} />
                <WelcomeBanner/>
            </div>
            <div className = 'slider' id = 'slider4'>
                <img alt = 'piglet' src = {piglet} />
                <WelcomeBanner/>
            </div>
            <div className= "changeSlideContainer">
                {widthX >= 425 && <div className = 'nextSlide' onClick={nextSlide}/>}
                {widthX >= 425 && <div className = 'prevSlide' onClick={prevSlide}/>}
            </div>

        </div>
    )
}

export default Slideshow;